import React, { useMemo } from 'react'
import { Stack } from 'react-bootstrap'
import { MeetingTemplate } from '../../../../store/ai/meetingTemplate'
import { useGetAccountQuery } from '../../../../store/accountUserSettings/accountUserSettings'
import { useAppSelector } from '../../../../store/hooks'
import { selectAccountId } from '../../../../store/auth/authSlice'
import { parseMetadata } from '../MeetingSummary/utils'
import { RoomSession } from '../../../../models/Room'

export interface MeetingScoreDisplayProps {
  meetingTemplate: MeetingTemplate | null
  roomSession: RoomSession | null
}

export const MeetingScoreDisplay: React.FC<MeetingScoreDisplayProps> = ({ meetingTemplate, roomSession }) => {
  const accountId = useAppSelector(selectAccountId)
  const { data: account } = useGetAccountQuery({ accountId }, { refetchOnMountOrArgChange: true })
  const meetingScorecardEnabled = account?.data.effectiveConfig.meetingScorecard ?? false

  const zockScore = useMemo(() => {
    if (!roomSession) {
      return null
    }
    const metadata = parseMetadata(roomSession.metadata)
    const externalSessionMetadata = metadata?.external ?? {}
    const id = meetingTemplate?.id
    if (id) {
      return externalSessionMetadata?.meetingScore?.[id] ?? null
    }
    return null
  }, [meetingTemplate?.id, roomSession])

  const getScoreColor = (zockScore: number) => {
    if (zockScore >= 60) {
      return 'zocks-bg-color-success-background zocks-text-success'
    } else if (zockScore >= 40) {
      return 'zocks-bg-color-warning zocks-text-warning-text'
    } else {
      return 'zocks-bg-color-danger-background zocks-text-danger'
    }
  }

  return (
    meetingScorecardEnabled &&
    zockScore && (
      <Stack direction='horizontal' className={`zocks-border-0.25 zocks-gap-0.25 p-1 align-items-center ${getScoreColor(zockScore)}`}>
        <i className='bi bi-graph-up'></i>
        <span className='lead-small'>{zockScore}</span>
      </Stack>
    )
  )
}
